/* Stylesheet */

.insights_options {
  margin: 52px 0px 0px 0px;

  .content_container {
    padding: 0px 0px 92px 0px;
  }
}
